import MainPageSecondScreenCommon from "./MainPageSecondScreenCommon";

export default class MainPageSecondScreenMobile {
    private readonly $holder: JQuery;

    public readonly $screen: JQuery;
    public readonly $screenContainer: JQuery;
    public readonly $topContent: JQuery;
    public readonly $bottomContent: JQuery;
    public readonly $bottomContentCards: JQuery;
    public readonly $bottomContentLinks: JQuery;
    public readonly $innerCenterPoint: JQuery;

    constructor($holder: JQuery) {
        this.$holder = $holder;

        const selectors = MainPageSecondScreenCommon.selectors;
        this.$screen = this.$holder.find(selectors.screen);
        this.$screenContainer = this.$screen.find(selectors.screenContainer);
        this.$topContent = this.$screenContainer.find(selectors.topContent);
        this.$bottomContent = this.$screenContainer.find(selectors.bottomContent);
        this.$bottomContentCards = this.$bottomContent.find(selectors.bottomContentCards);
        this.$bottomContentLinks = this.$bottomContent.find(selectors.bottomContentLinks);
        this.$innerCenterPoint = this.$screenContainer.find(selectors.innerCenterPoint);
    }
}
